import { NotificationDataType, NotificationType } from './common/types';

export const handleError = (setNotificationData: (value: React.SetStateAction<NotificationDataType | undefined>) => void, ex: any, errorMessage?: string, close?: () => void) => {
    // eslint-disable-next-line
    console.log(ex);

    if (ex.response && ex.response.error) {
        setNotificationData({ message: errorMessage ?? ex.response.error.includes('ORA') ? 'Ошибка при подключении к старой базе данных' : ex.response.error, close: () => close && close() });
    } else if (ex.response && ex.response.summary && typeof ex.response.summary[0] === 'string') {
        ex.response.summary[0] !== 'Данные отсутствуют' && setNotificationData({ message: errorMessage ?? ex.response.summary[0].includes('ORA') ? 'Ошибка при подключении к старой базе данных' : ex.response.summary[0], close: () => close && close() });
    } else if (ex.response?.errors) {
        let message = '';
        for (const [key, value] of Object.entries(ex.response.errors)) {
            message += `${ value } ${ String.fromCharCode(160) }`;
        }
        setNotificationData({ message, close: () => close && close() });
    } else {
        setNotificationData({ message: errorMessage ?? 'Неизвестная ошибка', close: () => close && close() });
    }
};
